import { render, staticRenderFns } from "./NDEConfectionPersonalizationForm.vue?vue&type=template&id=48aa204f&"
import script from "./NDEConfectionPersonalizationForm.vue?vue&type=script&lang=js&"
export * from "./NDEConfectionPersonalizationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports